import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Layouts/Header';
import Hero from './Sections/Hero';
import About from './Sections/About';
import Facts from './Sections/Facts';
import Products from './Sections/Products';
import Services from './Sections/Services';
import Clients from './Sections/Clients';
import Contact from './Sections/Contact';
import Footer from './Layouts/Footer';
import { fetchHomeData } from '../utils/apiService';

const Home = () => {
    const location = useLocation();
    const [cmsData, setCmsData] = useState(null);

    useEffect(() => {
        const getCmsData = async () => {
            const result = await fetchHomeData();
            if (result && result.status) {
                setCmsData(result.data);
            }
        };
        getCmsData();
    }, []);

    useEffect(() => {
        if (location.state?.scrollTo) {
            const timer = setTimeout(() => {
                const el = document.getElementById(location.state.scrollTo);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 600); // Wait for preloader to fade
            return () => clearTimeout(timer);
        }
    }, [location]);

    return (
        <div className="wrapper position-relative">
            <Header />
            <Hero data={cmsData?.home_hero_section} />
            <div className="main-content">
                <About
                    aboutData={cmsData?.home_about_section}
                    subAboutData={cmsData?.home_about_sub_section}
                />
                <Facts data={cmsData?.home_about_sub_section} />
                <Products />
                <Services />
                <Clients />
                <Contact />
            </div>
            <Footer />
        </div>
    );
};

export default Home;